import { render, staticRenderFns } from "./elems.vue?vue&type=template&id=768b0817&scoped=true&"
import script from "./elems.vue?vue&type=script&lang=js&"
export * from "./elems.vue?vue&type=script&lang=js&"
import style0 from "./elems.vue?vue&type=style&index=0&id=768b0817&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768b0817",
  null
  
)

export default component.exports